module.exports = __webpack_public_path__ + "img/bg-roles.969cbfff.png";